import { useCookie } from "@/composables";
import { AUTH_TOKEN_COOKIE } from "@/constants/auth";

export const AuthorizedGuard = () => {
  const tokenStorage = useCookie(AUTH_TOKEN_COOKIE);
  if (tokenStorage.get() === null) {
    return { name: "login" };
  }
  return true;
};
